const options = {
  5: "bg-red-300/5",
  10: "bg-red-300/10",
  25: "bg-red-300/25",
  50: "bg-red-300/50",
  75: "bg-red-300/75",
  90: "bg-red-300/90",
  100: "bg-red-300",
};

const from = {
  5: "from-red-300/5",
  10: "from-red-300/10",
  25: "from-red-300/25",
  50: "from-red-300/50",
  75: "from-red-300/75",
  90: "from-red-300/90",
  100: "from-red-300",
};

export default function getBackgroundRed300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
